import React from "react";
import star from "../../assets/img/star.png";
const Review = ({ scrollToConsult }) => {
  return (
    <div className="bg-theme my-4" style={{ height: "100%" }}>
      <div className="container py-5">
        <div className="row g-4">
          {/* First column with 2 cards */}
          <div className="col-lg-4 order-3 order-lg-1">
            <div className="card border border-1 border-light bg-transparent rounded-4 mb-3">
              <div className="card-body p-4">
                <p className="text-white fs-14 fw-100">
                  I wanted my teeth straightened and whitened as I had braces before but they had started to move back. I have never had so many compliments on my smile before, I am so happy with them and can't stop smiling. Thank you!
                </p>
              </div>
            </div>

            <div className="card border border-1 border-light bg-transparent rounded-4 mb-3">
              <div className="card-body p-4">
                <p className="text-white fs-14 fw-100">
                  I feel more confident and I smile more now that I have had my Invisalign. The team has been great all through my treatment. I would recommend to anyone looking to straighten their teeth.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 order-2 order-lg-2 mt-lg-5">
            <div className="card border border-1 border-light bg-transparent rounded-4 mb-3">
              <div className="card-body p-4">
                <p className="text-white fs-14 fw-100">
                  My teeth moved after having braces when I was younger and I came to get them straightened and the gap closed. He was amazing throughout the whole journey, very helpful, friendly and made me feel at ease. Now I have my perfect smile and I love it. Thank you  :)
                </p>
              </div>
            </div>

            <div className="card border border-1 border-light bg-transparent rounded-4">
              <div className="card-body p-4">
                <p className="text-white fs-14 fw-100">
                  Just started my Invisalign journey and it's been brilliant so far. The consultation and Clincheck stages went so smoothly and I'm so glad I chose to do it.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 mt-5 order-1 order-lg-3">
            <div className="d-flex justify-content-start mb-3">

              <i class="fa fa-star text-golden me-1" aria-hidden="true"></i>
              <i class="fa fa-star text-golden me-1" aria-hidden="true"></i>
              <i class="fa fa-star text-golden me-1" aria-hidden="true"></i>
              <i class="fa fa-star text-golden me-1" aria-hidden="true"></i>
              <i class="fa fa-star text-golden me-1" aria-hidden="true"></i>

            </div>
            <h2 className="fs-50 text-white">
              See what <span className="text-golden">our patients</span>{" "}
              have to say
            </h2>
            <p className="text-white">
              Read our 5-Star rated reviews from our delighted patients.
              We’d love you to join them.
            </p>
            <button className="btn-golden border-0" onClick={scrollToConsult} >
              <a href="#consult" className="text-white">
                BOOK A FREE CONSULTATION
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
